import styled from 'styled-components';

const ContainerStyled = styled.div`
  margin-bottom: 20px;
  background: #f4f4f7;
  border-radius: 8px;
  min-height: 48px;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 300px;
  padding: 14px 21px 14px 16px;
  flex-direction: column;
`;

const HeaderStyled = styled.div`
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  img {
    margin-right: 10px;
    transition: transform 0.3s ease;
    transform: rotate(90deg);
    &.toggled {
      transform: rotate(-90deg);
    }
  }
  p {
    font-family: 'cerapro';
    font-size: 16px;
    line-height: 19px;
    font-weight: 500;
    display: flex;
    align-items: center;
    color: #2d1441;
  }
`;

export { ContainerStyled, HeaderStyled };
